import { Http } from '../Utils/Http';
import { AxiosResponse } from 'axios';
import { ITopicCreateRequest } from './interfaces/Activities/ITopicCreateRequest';
import { ITopicViewpointResponse } from './interfaces/Activities/IViewpointData';
import { IChangeStatus } from './interfaces/Activities/IChangeStatus';
import { IUpdateActivityRequest } from './interfaces/Activities/IUpdateActivityRequest';
import { ITopicRequest } from './interfaces/Activities/ITopicRequest';
import {
  ICommentsRequest,
  ICreateCommentRequest,
  IDeleteCommentRequest,
  IEditCommentRequest,
} from './interfaces/Activities/IComments';
import {
  IFiltersRequestUpdatedDate,
  IFiltersResponseUpdatedDate,
} from './interfaces/Activities/IFiltersRequest';
import {
  IFollowersAddRequest,
  IFollowersDeleteRequest,
  IFollowersResponse,
} from './interfaces/Activities/IFollowers';
import { IRenameAttachmentRequest } from './interfaces/Activities/IAttachment';

export class ActivitiesApi {
  static async listActivities(request: ITopicRequest): Promise<AxiosResponse<any>> {
    const axios = await Http.axios();
    return axios.get(`/Topic/Get?constructionSiteId=${request.csId}${request.filtersId ? `&filterId=${request.filtersId}` : ''}`);
  }

  static async createActivity(request: ITopicCreateRequest): Promise<AxiosResponse<any>> {
    const axios = await Http.axios();
    return axios.post('/Topic/Post', request);
  }

  static async updateActivity(request: IUpdateActivityRequest): Promise<AxiosResponse<any>> {
    const axios = await Http.axios();
    return axios.patch(`/Topic/Patch/${request.Guid}`, request.updateData);
  }

  static async changeStatus(request: IChangeStatus): Promise<AxiosResponse<any>> {
    const axios = await Http.axios();
    return axios.patch(`/Topic/Patch/${request.Guid}`, request.updateData);
  }

  static async deleteActivity(activityId: string): Promise<AxiosResponse<any>> {
    const axios = await Http.axios();
    return axios.delete(`/Topic/Delete/${activityId}`);
  }

  static async renameAttachment(request: IRenameAttachmentRequest): Promise<AxiosResponse<any>> {
    const axios = await Http.axios();
    return axios.put('/Topic/RenameAttachment', request);
  }

  static async deleteAttachmentForCreate(fileId: string): Promise<AxiosResponse<any>> {
    const axios = await Http.axios();
    return axios.delete(`/Topic/DeleteNewAttachment/${fileId}`);
  }

  static async deleteAttachment(topicAttachmentId: number): Promise<AxiosResponse<any>> {
    const axios = await Http.axios();
    return axios.delete(`/Topic/DeleteExistingAttachment/${topicAttachmentId}`);
  }

  static async listHistory(topicId: string): Promise<AxiosResponse<any>> {
    const axios = await Http.axios();
    return axios.get(`/topic/${topicId}/history`);
  }

  static async listComments(request: ICommentsRequest): Promise<AxiosResponse<any>> {
    const axios = await Http.axios();
    return axios.get(`/topic/${request.topicId}/comments`);
  }

  static async createComment(request: ICreateCommentRequest): Promise<AxiosResponse<any>> {
    const axios = await Http.axios();
    return axios.post(`/topic/${request.topicId}/comments`, request.data);
  }

  static async editComment(request: IEditCommentRequest): Promise<AxiosResponse<any>> {
    const axios = await Http.axios();
    return axios.put(`/topic/${request.topicId}/comments/${request.commentId}`, request.data);
  }

  static async deleteComment(request: IDeleteCommentRequest): Promise<AxiosResponse<any>> {
    const axios = await Http.axios();
    return axios.delete(`/topic/${request.topicId}/comments/${request.commentId}`);
  }

  static async readComments(topicId: string): Promise<AxiosResponse<any>> {
    const axios = await Http.axios();
    return axios.put(`/topic/${topicId}/comments/read`);
  }

  static async listUpdatedDate(
    request: IFiltersRequestUpdatedDate,
  ): Promise<AxiosResponse<IFiltersResponseUpdatedDate>> {
    const axios = await Http.axios();
    return axios.get(`/topic/updated-data?constructionSiteId=${request.csId}${request?.from ? `&from=${request.from}` : ''}${request?.to ? `&to=${request.to}` : ''}`);
  }

  static async listFollowers(request: string): Promise<AxiosResponse<IFollowersResponse>> {
    const axios = await Http.axios();
    return axios.get(`/topic/${request}/followers`);
  }

  static async addFollowers(request: IFollowersAddRequest): Promise<AxiosResponse<IFollowersResponse>> {
    const axios = await Http.axios();
    return axios.post(`/topic/${request.topicId}/followers`, request.followers.map((follower) => follower.Id));
  }

  static async deleteFollowers(request: IFollowersDeleteRequest): Promise<AxiosResponse<IFollowersResponse>> {
    const axios = await Http.axios();
    return axios.delete(`/topic/${request.topicId}/followers`, { data: request.followers });
  }

  static async getTopicViewpoint(
    topicId: string,
    viewpointId: string,
  ): Promise<AxiosResponse<{ success: boolean; data: ITopicViewpointResponse }>> {
    const axios = await Http.axios();
    return axios.get(`/topic/${topicId}/viewpoints/${viewpointId}`);
  }
}
